import React from 'react';
import { Select } from 'antd-v5';
import PropTypes from 'prop-types';

const StoresFilter = ({ stores, includedStoreIds, onChange }) => {
  const options = stores.map(s => ({ label: s.name, value: s.id }));

  return (
    <div className="audience-filter-section">
      <div className="audience-filter-label">Include stores</div>
      <Select
        mode="multiple"
        placeholder="Select stores to include"
        value={includedStoreIds}
        onChange={onChange}
        options={options}
        style={{ width: '100%' }}
        allowClear
        maxTagCount="responsive"
      />
    </div>
  );
};

StoresFilter.propTypes = {
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
  includedStoreIds: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

StoresFilter.defaultProps = {
  stores: [],
  includedStoreIds: [],
};

export default StoresFilter;
